import moment from 'moment';
import { IPagination } from '../../../types/pagination';
import { IProject } from '../../project/types/project';
import * as constants from '../actions/constants';
import { ReportsActions } from '../actions/reportsActions';
import {
  IDataLoader,
  IDepartmentUtilizationFilterData, IExpenditurePhasingTable, IFTEByProject, IGlobalReportDepartmentUtilizationData, IGlobalReportExpectedPaymentsData, IGlobalReportExpenditurePhasingData, IGlobalReportHoursPhasingData, IProjectHoursPhasingFilterData, IProjectList, IProjectListFilterData,
  IReport, IReportChart, IReportFilter, ITasksByProject, ITasksByProjectFilterData
} from './../types/reports';

export const _initialFilters: IReportFilter[] = [
  { key: 'all_reports', name: 'All Reports', minWidth: '7rem' },
  { key: 'projects', name: 'Projects', minWidth: '6.5rem', count: 0 },
  { key: 'time_tracking', name: 'Time Tracking', minWidth: '9.5rem', count: 0 },
  { key: 'accounting', name: 'Accounting', minWidth: '8.5rem', count: 0 },
]
export const _initialTasksByProjectFilters: ITasksByProjectFilterData = { projects: [], phases: [], departments: [], status: [] }
export const _initialProjectListFilters: IProjectListFilterData = { projects: [], phases: [], health: [], status: [] }
export const _initialFTEByProject: IFTEByProject = {
  project: {
    name: '',
    start_date: null,
    end_date: null,
    fte_hours_per_month: 0,  // Will be populated from API
    data: {
      links: { next: '', previous: '' },
      count: 0,
      current_page: 0,
      total_pages: 0,
      results: [],
      page_size: 5,
      last_page: 0,
      to: 0,
      from: 0
    }
  }
}
export const _initialDepartmentUtilizationFilters: IDepartmentUtilizationFilterData = { projects: [], employees: [], departments: [], tasks: [] }
export const _initialProjectHoursPhasingFilters: IProjectHoursPhasingFilterData = { projects: [], departments: [] }
export const _initialPaginatedTasksByProject: IPagination<ITasksByProject[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}
export const _initialPaginatedExpPhasing: IPagination<IExpenditurePhasingTable[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}
export const _initialPaginatedProjectList: IPagination<IProject[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

const _initialPagination = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}
export const _initialDepartmentUtilizationData: IGlobalReportDepartmentUtilizationData = {
  years: [],
  paginated_data: _initialPagination
}
export const _initialExpenditurePhasing: IGlobalReportExpenditurePhasingData = {
  years: [],
  paginated_data: _initialPagination
}
export const _initialHoursPhasing: IGlobalReportHoursPhasingData = {
  years: [],
  paginated_data: _initialPagination
}
export const _initialExpectedPayments: IGlobalReportExpectedPaymentsData = {
  years: [],
  paginated_data: _initialPagination
}

export const reports = (state: IReport[] = [], action: ReportsActions): IReport[] => {
  switch (action.type) {
    case constants.GET_REPORTS_SUCCESS:
      return action.reports

    default:
      return state
  }
}

export const reportsFilters = (state: IReportFilter[] = _initialFilters, action: ReportsActions): IReportFilter[] => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialFilters
    case constants.GET_REPORTS_SUCCESS:
      return state.map(f => {
        if (f.key !== 'all_reports') {
          f.count = action.reports.filter(p => p.labels.includes(f.name)).length
        }
        return f
      })

    default:
      return state
  }
}

export const reportsFilter = (state: IReportFilter = _initialFilters[0], action: ReportsActions): IReportFilter => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialFilters[0]
    case constants.SET_REPORTS_FILTER:
      return action.report

    default:
      return state
  }
}

export const tasksByProjectsFilter = (state: ITasksByProjectFilterData = _initialTasksByProjectFilters, action: ReportsActions): ITasksByProjectFilterData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialTasksByProjectFilters
    case constants.GET_TASKS_BY_PROJECT_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const paginatedTasksByProject = (state: IPagination<ITasksByProject[]> = _initialPaginatedTasksByProject, action: ReportsActions): IPagination<ITasksByProject[]> => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialPaginatedTasksByProject
    case constants.GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialPaginatedTasksByProject
    }

    default:
      return state
  }
}

export const paginationPageTasksByProject = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_TASKS_BY_PROJECT:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const checkLoader = (state = false, action: ReportsActions): boolean => {
  switch (action.type) {
    case constants.SET_LOADER:
      return action.load

    default:
      return state
  }
}

export const checkDataLoader = (state: IDataLoader = { data: false, chart: false }, action: ReportsActions): IDataLoader => {
  switch (action.type) {
    case constants.SET_DATA_LOADER:
      return action.load

    default:
      return state
  }
}

export const tasksByProjectSort = (state = { name: 'name', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'name', direction: 'asc' }
    case constants.SET_TASKS_BY_PROJECT_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'name', direction: 'asc' }
    }

    default:
      return state
  }
}

export const projectListFilter = (state: IProjectListFilterData = _initialProjectListFilters, action: ReportsActions): IProjectListFilterData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialProjectListFilters
    case constants.GET_PROJECT_LIST_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const projectList = (state: IPagination<IProject[]> = _initialPaginatedProjectList, action: ReportsActions): IPagination<IProject[]> => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialPaginatedProjectList
    case constants.GET_PROJECT_LIST_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialPaginatedProjectList
    }

    default:
      return state
  }
}

export const paginationPageProjectList = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_PROJECT_LIST:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const projectListSort = (state = { name: 'name', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'name', direction: 'asc' }
    case constants.SET_PROJECT_LIST_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'name', direction: 'asc' }
    }

    default:
      return state
  }
}

export const FTEByProjectFilter = (state: IProjectList = { projects: [] }, action: ReportsActions): IProjectList => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { projects: [] }
    case constants.GET_FTE_BY_PROJECT_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const FTEByProject = (state: IFTEByProject = _initialFTEByProject, action: ReportsActions): IFTEByProject => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialFTEByProject
    case constants.GET_FTE_BY_PROJECT_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialFTEByProject
    }

    default:
      return state
  }
}

export const paginationPageFTEByProject = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_FTE_BY_PROJECT:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const FTEByProjectSort = (state = { name: 'department_name', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'department_name', direction: 'asc' }
    case constants.SET_FTE_BY_PROJECT_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'department_name', direction: 'asc' }
    }

    default:
      return state
  }
}

export const expenditurePhasing = (state: IGlobalReportExpenditurePhasingData = _initialExpenditurePhasing, action: ReportsActions): IGlobalReportExpenditurePhasingData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialExpenditurePhasing
    case constants.GET_EXPENDITURE_PHASING_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialExpenditurePhasing
    }

    default:
      return state
  }
}

export const paginationPageExpenditurePhasing = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_EXPENDITURE_PHASING:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const expenditurePhasingSort = (state = { name: 'month', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'month', direction: 'asc' }
    case constants.SET_EXPENDITURE_PHASING_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'month', direction: 'asc' }
    }

    default:
      return state
  }
}

export const expenditurePhasingChartDataType = (state = { type: 'month', year: moment().year() }, action: ReportsActions): { type: string, year: number } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { type: 'month', year: moment().year() }
    case constants.SET_EXPENDITURE_PHASING_CHART_TYPE:
      return action.chart
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { type: 'month', year: moment().year() }
    }

    default:
      return state
  }
}

export const expenditurePhasingChart = (state: IReportChart = { categories: [], data: [] }, action: ReportsActions): IReportChart => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { categories: [], data: [] }
    case constants.GET_EXPENDITURE_PHASING_CHART_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { categories: [], data: [] }
    }
    default:
      return state
  }
}

export const departmentUtilizationFilter = (state: IDepartmentUtilizationFilterData = _initialDepartmentUtilizationFilters, action: ReportsActions): IDepartmentUtilizationFilterData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialDepartmentUtilizationFilters
    case constants.GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const departmentUtilization = (state: IGlobalReportDepartmentUtilizationData = _initialDepartmentUtilizationData, action: ReportsActions): IGlobalReportDepartmentUtilizationData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialDepartmentUtilizationData
    case constants.GET_DEPARTMENT_UTILIZATION_SUCCESS:
      return action.entries
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialDepartmentUtilizationData
    }

    default:
      return state
  }
}

export const paginationPageDepartmentUtilization = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const departmentUtilizationSort = (state = { name: 'project_name', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'project_name', direction: 'asc' }
    case constants.SET_DEPARTMENT_UTILIZATION_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'project_name', direction: 'asc' }
    }

    default:
      return state
  }
}

export const departmentUtilizationChartDataType = (state = { type: 'month', year: moment().year() }, action: ReportsActions): { type: string, year: number } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { type: 'month', year: moment().year() }
    case constants.SET_DEPARTMENT_UTILIZATION_CHART_TYPE:
      return action.chart
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { type: 'month', year: moment().year() }
    }

    default:
      return state
  }
}

export const departmentUtilizationChart = (state: IReportChart = { categories: [], data: [] }, action: ReportsActions): IReportChart => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { categories: [], data: [] }
    case constants.GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { categories: [], data: [] }
    }

    default:
      return state
  }
}

export const projectHoursPhasingFilter = (state: IProjectHoursPhasingFilterData = _initialProjectHoursPhasingFilters, action: ReportsActions): IProjectHoursPhasingFilterData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialProjectHoursPhasingFilters
    case constants.GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const projectHoursPhasing = (state: IGlobalReportHoursPhasingData = _initialHoursPhasing, action: ReportsActions): IGlobalReportHoursPhasingData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialHoursPhasing
    case constants.GET_PROJECT_HOURS_PHASING_SUCCESS:
      return action.entries
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialHoursPhasing
    }

    default:
      return state
  }
}

export const paginationPageProjectHoursPhasing = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const projectHoursPhasingSort = (state = { name: 'month', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'month', direction: 'asc' }
    case constants.SET_PROJECT_HOURS_PHASING_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'month', direction: 'asc' }
    }

    default:
      return state
  }
}

export const projectHoursPhasingChartDataType = (state = { type: 'month', year: moment().year() }, action: ReportsActions): { type: string, year: number } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { type: 'month', year: moment().year() }
    case constants.SET_PROJECT_HOURS_PHASING_CHART_TYPE:
      return action.chart
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { type: 'month', year: moment().year() }
    }

    default:
      return state
  }
}


export const projectHoursPhasingChart = (state: IReportChart = { categories: [], data: [] }, action: ReportsActions): IReportChart => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { categories: [], data: [] }
    case constants.GET_PROJECT_HOURS_PHASING_CHART_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { categories: [], data: [] }
    }

    default:
      return state
  }
}

export const expectedPaymentsFilter = (state: IProjectList = { projects: [] }, action: ReportsActions): IProjectList => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { projects: [] }
    case constants.GET_EXPECTED_PAYMENTS_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const expectedPayments = (state: IGlobalReportExpectedPaymentsData = _initialExpectedPayments, action: ReportsActions): IGlobalReportExpectedPaymentsData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialExpectedPayments
    case constants.GET_EXPECTED_PAYMENTS_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialExpectedPayments
    }

    default:
      return state
  }
}

export const paginationPageExpectedPayments = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_EXPECTED_PAYMENTS:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const expectedPaymentsSort = (state = { name: 'month', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'month', direction: 'asc' }
    case constants.SET_EXPECTED_PAYMENTS_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'month', direction: 'asc' }
    }

    default:
      return state
  }
}

export const expectedPaymentsChart = (state: IReportChart = { categories: [], data: [] }, action: ReportsActions): IReportChart => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { categories: [], data: [] }
    case constants.GET_EXPECTED_PAYMENTS_CHART_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { categories: [], data: [] }
    }

    default:
      return state
  }
}

export const expectedPaymentsChartDataType = (state = { type: 'month', year: moment().year() }, action: ReportsActions): { type: string, year: number } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { type: 'month', year: moment().year() }
    case constants.SET_EXPECTED_PAYMENTS_CHART_TYPE:
      return action.chart
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { type: 'month', year: moment().year() }
    }

    default:
      return state
  }
}

export const expectedReceiptsFilter = (state: IProjectList = { projects: [] }, action: ReportsActions): IProjectList => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { projects: [] }
    case constants.GET_EXPECTED_RECEIPTS_FILTER_SUCCESS:
      return action.data

    default:
      return state
  }
}

export const expectedReceipts = (state: IGlobalReportExpectedPaymentsData = _initialExpectedPayments, action: ReportsActions): IGlobalReportExpectedPaymentsData => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return _initialExpectedPayments
    case constants.GET_EXPECTED_RECEIPTS_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return _initialExpectedPayments
    }

    default:
      return state
  }
}

export const paginationPageExpectedReceipts = (state = '1', action: ReportsActions): string => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return '1'
    case constants.SET_PAGINATION_PAGE_EXPECTED_RECEIPTS:
      return action.page
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return '1'
    }

    default:
      return state
  }
}

export const expectedReceiptsSort = (state = { name: 'month', direction: 'asc' }, action: ReportsActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { name: 'month', direction: 'asc' }
    case constants.SET_EXPECTED_RECEIPTS_SORT:
      return action.sort
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { name: 'month', direction: 'asc' }
    }

    default:
      return state
  }
}

export const expectedReceiptsChart = (state: IReportChart = { categories: [], data: [] }, action: ReportsActions): IReportChart => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { categories: [], data: [] }
    case constants.GET_EXPECTED_RECEIPTS_CHART_SUCCESS:
      return action.data
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { categories: [], data: [] }
    }

    default:
      return state
  }
}

export const expectedReceiptsChartDataType = (state = { type: 'month', year: moment().year() }, action: ReportsActions): { type: string, year: number } => {
  switch (action.type) {
    case constants.CLEAR_REPORTS_STATE:
      return { type: 'month', year: moment().year() }
    case constants.SET_EXPECTED_RECEIPTS_CHART_TYPE:
      return action.chart
    case constants.SET_FILTER_PARAMS: {
      if (Object.keys(action.params).length > 0) {
        return state
      }
      return { type: 'month', year: moment().year() }
    }

    default:
      return state
  }
}
